import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

export default function ColorMultiImages({ colorImageUrls, title }) {
  const [imagesLoaded, setAllImagesLoaded] = useState(0)
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)
  const [mouseClicked, setMouseClicked] = useState(false)
  const [initialMouseX, setInitialMouseX] = useState(null)
  const elementRef = useRef(null)

  const getClientX = (e) => (e.touches ? e.touches[0].clientX : e.clientX)

  const handleStart = (e) => {
    setMouseClicked(true)
    setInitialMouseX(getClientX(e))
  }

  const handleEnd = () => {
    setMouseClicked(false)
    setInitialMouseX(null)
  }

  const handleMove = (e) => {
    if (!mouseClicked || initialMouseX === null) {
      return
    }

    const element = elementRef.current

    if (!element) {
      return
    }

    const { width } = element.getBoundingClientRect()
    const threshold = width / (colorImageUrls.length * 2)
    const currentX = getClientX(e)
    const deltaX = currentX - initialMouseX

    if (deltaX > threshold) {
      setSelectedImageIndex((prevIndex) => (prevIndex - 1 + colorImageUrls.length) % colorImageUrls.length)
      setInitialMouseX(currentX)
    } else if (deltaX < -threshold) {
      setSelectedImageIndex((prevIndex) => (prevIndex + 1) % colorImageUrls.length)
      setInitialMouseX(currentX)
    }
  }

  useEffect(() => {
    const element = elementRef.current

    if (!element) {
      return
    }

    // Mouse events
    element.addEventListener('mousedown', handleStart)
    window.addEventListener('mouseup', handleEnd)
    element.addEventListener('mousemove', handleMove)

    // Touch events
    element.addEventListener('touchstart', handleStart)
    window.addEventListener('touchend', handleEnd)
    element.addEventListener('touchmove', handleMove)

    return () => {
      element.removeEventListener('mousedown', handleStart)
      window.removeEventListener('mouseup', handleEnd)
      element.removeEventListener('mousemove', handleMove)

      element.removeEventListener('touchstart', handleStart)
      window.removeEventListener('touchend', handleEnd)
      element.removeEventListener('touchmove', handleMove)
    };
  }, [mouseClicked, initialMouseX])

  useEffect(() => {
    setAllImagesLoaded(0)

    if (selectedImageIndex >= colorImageUrls.length) {
      setSelectedImageIndex(0)
    }
  }, [JSON.stringify(colorImageUrls)])

  return (
    <>
      <div
        ref={elementRef}
        className={classNames('multi-image__container', {
          'multi-image--loading': colorImageUrls.length !== imagesLoaded
        })}
      >
        {colorImageUrls.map((colorImageUrl, index) => (
          <img
            key={index}
            src={colorImageUrl}
            alt={title}
            title={title}
            className={classNames({
              'selected': index === selectedImageIndex
            })}
            draggable='false'
            onLoad={() => setAllImagesLoaded((prev) => prev + 1)}
          />
        ))}
      </div>
    </>
  )
}
